export const ParseHgFarmerResult = (result) => {
  const tempResults = JSON.parse(JSON.stringify(result));
  
  tempResults.resultList = [];
  result.resultList.forEach(value => {
    const splitValue = value.resultName.split(':');
    if (splitValue.length > 0) {
      let findValue = tempResults.resultList.find(x => x.resultName === splitValue[0]);
      if (findValue) {
        findValue.resultValue += value.resultValue;
      } else {
        value.resultName = splitValue[0];
        tempResults.resultList.push(value);
      }
    }
  });
  tempResults.resultList.sort((a, b) => b.resultValue - a.resultValue);

  return tempResults;
}